import { createAction } from 'redux-actions'

export const setNewSearchFlowData = createAction('SET_NEW_SEARCH_FLOW_DATA')
export const clearNewSearchFlowData = createAction('CLEAR_NEW_SEARCH_FLOW_DATA')
export const resetDiscardedParticipants = createAction(
  'RESET_DISCARDED_PARTICIPANTS'
)
